import React from 'react';
import { Checkbox, Typography, Flex, InputNumber } from 'antd';
import WidgetFooter from './WidgetFooter';
import { FilterDropdownProps } from 'antd/lib/table/interface';

export type ResponseTimeFilter = Partial<{
  responseTimeLow: number;
  responseTimeHigh: number;
  timedout: boolean;
}>;

type ResponseTimeDropdownFilterProps = Pick<FilterDropdownProps, 'confirm' | 'clearFilters'> & {
  selectedKeys: ResponseTimeFilter[];
  setSelectedKeys: (keys: ResponseTimeFilter[]) => void;
  useMilliseconds?: boolean;
};

function ResponseDropdownFilter({
  confirm,
  selectedKeys,
  setSelectedKeys,
  clearFilters,
  useMilliseconds = false,
}: ResponseTimeDropdownFilterProps) {
  const responseTime = selectedKeys.length ? selectedKeys[0] : {};
  const responseTimeLow = responseTime.responseTimeLow
    ? responseTime.responseTimeLow / (useMilliseconds ? 1000 : 1)
    : undefined;
  const responseTimeHigh = responseTime.responseTimeHigh
    ? responseTime.responseTimeHigh / (useMilliseconds ? 1000 : 1)
    : undefined;

  const onFieldChange = (field: keyof ResponseTimeFilter, value: any) => {
    if (useMilliseconds && field !== 'timedout') setSelectedKeys([{ ...responseTime, [field]: value * 1000 }]);
    else setSelectedKeys([{ ...responseTime, [field]: value }]);
  };

  const onReset = () => clearFilters?.();

  const disabled =
    responseTime.responseTimeLow === null && responseTime.responseTimeHigh === null && !responseTime.timedout;

  React.useEffect(() => {
    return () => confirm();
  }, []);

  return (
    <Flex vertical style={{ padding: 12 }}>
      <Typography.Text>Response Time in Sec.</Typography.Text>
      <Flex align="center" style={{ margin: '12px 0' }}>
        <Typography.Text>Between</Typography.Text>
        <InputNumber
          min={0.1}
          max={100}
          step={useMilliseconds ? 0.1 : 1}
          style={{ width: 80, margin: '0 6px' }}
          placeholder="0.5"
          value={responseTimeLow}
          onChange={(value) => onFieldChange('responseTimeLow', value)}
        />
        <Typography.Text>and</Typography.Text>
        <InputNumber
          min={0.1}
          max={100}
          step={useMilliseconds ? 0.1 : 1}
          style={{ width: 80, margin: '0 6px' }}
          placeholder="100"
          value={responseTimeHigh}
          onChange={(value) => onFieldChange('responseTimeHigh', value)}
        />
      </Flex>
      <Checkbox checked={responseTime?.timedout || false} onChange={(e) => onFieldChange('timedout', e.target.checked)}>
        Timed out
      </Checkbox>
      <WidgetFooter onOk={() => confirm()} resetDisabled={disabled} onReset={onReset} />
    </Flex>
  );
}

export default ResponseDropdownFilter;
